import { CSSProperties, useEffect, useState } from "react";

export interface PerformerAvatarProps {
  src?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  style?: CSSProperties;
  className?: string;
}

export default function PerformerAvatar({
  src,
  firstName,
  lastName,
  style,
  className,
}: PerformerAvatarProps) {
  const [imgSrc, setImgSrc] = useState(src || null);

  useEffect(() => {
    setImgSrc(src || null);
  }, [src]);

  const initials = `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase();

  if (!imgSrc) {
    return (
      <div
        className={className}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "9999px",
          background: "hsl(var(--muted))",
          color: "hsl(var(--muted-foreground))",
          fontSize: 12,
          fontWeight: 600,
          flexShrink: 0,
          ...style,
        }}
      >
        {initials || "?"}
      </div>
    );
  }

  return (
    <img
      src={imgSrc}
      alt={`${firstName ?? ""} ${lastName ?? ""}`.trim()}
      style={{ objectFit: "cover", borderRadius: "9999px", flexShrink: 0, ...style }}
      className={className}
      onError={() => setImgSrc(null)}
    />
  );
}
